import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {
  FP_ROUTES,
  HAS_FACTURATION,
  HAS_GESTIONCOMMANDES, HAS_ROLE_COMMANDES_FOURNISSEURS_RECEPTION,
  HAS_ROLE_COMMANDES_FOURNISSEURS_TABLEAU_DE_BORD,
  HAS_STOCKS
} from "../core/constants";
import {GcfRootComponent} from "./gcf-root/gcf-root.component";
import {Auth2Guard} from "../core/services/security/auth2.guard";
import {BcAValiderComponent} from "./bc/bc-a-valider/bc-a-valider.component";
import {BcPropositionsComponent} from "./bc/bc-propositions/bc-propositions.component";
import {BcFactureesComponent} from "./bc/bc-facturees/bc-facturees.component";
import {TableauDeBordComponent} from "./tableau-de-bord/tableau-de-bord.component";
import {TableauDeBordResolverService} from "./tableau-de-bord/tableau-de-bord-resolver.service";
import {BcComponent} from "./bc/bc.component";
import {BcReceptionsComponent} from "./bc/bc-receptions/bc-receptions.component";
import {BcAReceptionnerComponent} from "./bc/bc-a-receptionner/bc-a-receptionner.component";
import {BcRefuseesComponent} from "./bc/bc-refusees/bc-refusees.component";

const routes: Routes = [
  {
    path: FP_ROUTES.GESTION_COMMANDES_FOURNISSEURS,
    component: GcfRootComponent,
    canActivate: [Auth2Guard],
    canActivateChild: [Auth2Guard],
    runGuardsAndResolvers: 'always',
    data: {
      rule: {
        or: [
          { role: HAS_GESTIONCOMMANDES },
          { role: HAS_ROLE_COMMANDES_FOURNISSEURS_TABLEAU_DE_BORD },
          { and: [
              { role: HAS_STOCKS },
              { role: HAS_ROLE_COMMANDES_FOURNISSEURS_RECEPTION }
            ]
          }
        ]
      }
    },
    children: [
      {
        path: 'bc',
        component: BcComponent,
        data: {
          rule: {
            or: [
              { role: HAS_GESTIONCOMMANDES },
              { role: HAS_ROLE_COMMANDES_FOURNISSEURS_TABLEAU_DE_BORD },
              { and: [
                  { role: HAS_STOCKS },
                  { role: HAS_ROLE_COMMANDES_FOURNISSEURS_RECEPTION }
                ]
              }
            ]
          }
        },
        runGuardsAndResolvers: 'always',
        children: [
          {
            path: 'tableau-de-bord',
            component: TableauDeBordComponent,
            runGuardsAndResolvers: 'always',
            data: {
              roles: [HAS_ROLE_COMMANDES_FOURNISSEURS_TABLEAU_DE_BORD]
            },
            resolve: {
              dashboardSupplier: TableauDeBordResolverService
            }
          },
          {
            path: 'propositions',
            component: BcPropositionsComponent,
            runGuardsAndResolvers: 'always',
            data: {
              roles: [HAS_GESTIONCOMMANDES]
            }
          },
          {
            path: 'refusees',
            component: BcRefuseesComponent,
            runGuardsAndResolvers: 'always',
            data: {
              roles: [HAS_GESTIONCOMMANDES]
            }
          },
          {
            path: 'a-valider',
            component: BcAValiderComponent,
            runGuardsAndResolvers: 'always',
            data: {
              roles: [HAS_GESTIONCOMMANDES]
            }
          },
          {
            path: 'a-receptionner',
            component: BcAReceptionnerComponent,
            runGuardsAndResolvers: 'always',
            data: {
              roles: [
                HAS_ROLE_COMMANDES_FOURNISSEURS_RECEPTION,
                HAS_STOCKS
              ],
              permission: 'AND'
            }
          },
          {
            path: 'receptions',
            component: BcReceptionsComponent,
            runGuardsAndResolvers: 'always',
            data: {
              roles: [
                HAS_ROLE_COMMANDES_FOURNISSEURS_RECEPTION,
                HAS_STOCKS
              ],
              permission: 'AND'
            },
          },
          {
            path: 'facturees',
            component: BcFactureesComponent,
            runGuardsAndResolvers: 'always',
            data: {
              roles: [HAS_FACTURATION]
            }
          },
        ]
      },

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GestionCommandesFournisseursRoutingModule {
}
